import { Info, Phone, Video } from 'lucide-react';
import { useEffect, useState } from 'react';
import { PiFlagFill } from 'react-icons/pi';

import { BubbleAvatar } from '../common/bubble-avatar.ui';
import { ExpandableChatHeader } from './expandable-chat';

import { User } from '@/slw/entities/chat';
import { useChatStore } from '@/slw/shared/lib/firebase/chat-store';
import { onlineStatusService } from '@/slw/shared/lib/firebase/online-status';
import { cn } from '@/slw/shared/lib/utils';

interface ChatTopBarProps {
  selectedUser: User | null;
  isLoading?: boolean;
  onReport?: () => void;
}

export const TopBarIcons = [{ icon: Phone }, { icon: Video }, { icon: Info }];

export const ChatTopBar = ({ selectedUser, isLoading, onReport }: ChatTopBarProps) => {
  const { user } = useChatStore();
  const [isOnline, setIsOnline] = useState(user?.isOnline || false);

  useEffect(() => {
    if (!user?.id) return;

    const unsubscribe = onlineStatusService.getOnlineStatus(user?.id, (online) => {
      setIsOnline(online);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user?.id]);

  return (
    <ExpandableChatHeader>
      <div className='flex items-center gap-2 w-full'>
        <div className='relative'>
          <BubbleAvatar src={selectedUser?.avatarUrl} name={selectedUser?.username || ''} />
          <div
            className={cn(
              'absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white',
              isOnline ? 'bg-green-500' : 'bg-gray-400',
            )}
            title={isOnline ? 'Online' : 'Offline'}
          />
        </div>
        <div className='flex flex-col'>
          <span className='font-medium'>{selectedUser?.username}</span>
          <span className='text-xs space-x-1'>
            <span>{selectedUser?.email}</span>
            <span>{selectedUser?.phoneNumber ? `(${selectedUser?.phoneNumber})` : ''}</span>
          </span>
        </div>
        <button
          type='button'
          disabled={isLoading}
          aria-label='Report listing'
          onClick={onReport}
          className={cn('cursor-pointer ml-auto ', isLoading && 'opacity-50 pointer-events-none')}
        >
          <PiFlagFill size={24} className='text-gray-500' />
          <span className='sr-only'>Report</span>
        </button>
      </div>

      {/* <div className='flex gap-1'>
        {TopBarIcons.map((icon, index) => (
          <Link key={index} href='#' className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'h-9 w-9')}>
            <icon.icon size={20} className='text-muted-foreground' />
          </Link>
        ))}
      </div>*/}
    </ExpandableChatHeader>
  );
};
